import {
  Spinner,
} from '@codev/helix-react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';
import React from 'react';
import truncate from 'truncate';
import Step1 from './Step1.jsx';
import Step2 from './Step2.jsx';
import Step3 from './Step3.jsx';

const View = ({
  issuer,
  language,
  loading,
  onChange,
  onShowStep2Tooltip,
  secretKey,
  style,
  username,
  verificationCode,
  ...rest
}) => (
  <div
    {...rest}
    style={{
      fontSize: '16px',
      ...style
    }}
  >
    {
      loading &&
      <div
        style={{
          alignItems: 'center',
          display: 'flex',
          height: '401px',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <Spinner
          className="warning"
          style={{
            height: '3em',
            width: '3em',
          }}
        />
      </div>
    }
    {
      !loading &&
      <span>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            marginTop: '20px',
          }}
        >
          <div
            id="steps"
            style={{
              width: '495px',
            }}
          >
            <Step1 language={language} />
            <Step2 language={language} secretKey={secretKey} />
            <Step3 language={language} onChange={onChange} verificationCode={verificationCode} />
          </div>

          <div style={{marginTop: '20px'}}>
            <QRCode size={225} value={`otpauth://totp/${encodeURIComponent(truncate(username, 32))}?secret=${secretKey}&issuer=${encodeURIComponent(truncate(issuer, 32))}`} />
          </div>
        </div>
      </span>
    }
  </div>
);

View.defaultProps = {
  language: 'en_US',
  verificationCode: '',
};

View.propTypes = {
  issuer: PropTypes.string.isRequired,
  language: PropTypes.string,
  loading: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onShowStep2Tooltip: PropTypes.func,
  secretKey: PropTypes.string.isRequired,
  style: PropTypes.object,
  username: PropTypes.string.isRequired,
  verificationCode: PropTypes.string,
};

export default View;